interface LogoProps {
  size?: number;
  textSize?: number;
  compact?: boolean;
  // The mark is floored at 28px so it stays legible wherever the logo is
  // placed. The site header on a phone asks for a smaller one explicitly,
  // keeping its 44px tap area through padding instead of size.
  markSize?: number;
}

export default function Logo({ size = 24, textSize = 16, compact = false, markSize: explicitMarkSize }: LogoProps) {
  const markSize = explicitMarkSize ?? Math.max(size, 28);

  return (
    <span
      className="brand-logo"
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: compact ? 6 : 8,
        minWidth: 0,
      }}
    >
      <span
        className="brand-logo-mark-wrap"
        style={{
          width: markSize,
          height: markSize,
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "var(--radius-sm)",
          background: "var(--color-surface-muted)",
          flexShrink: 0,
        }}
      >
        <svg
          className="brand-logo-mark"
          width={markSize}
          height={markSize}
          viewBox="0 0 64 64"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
          focusable="false"
        >
          <path d="M11 49L28.5 14H36L53 55H44.5L32.2 25.5L22 45H37.8L41.2 49H11Z" fill="var(--color-brand-dark)" />
          <path d="M54.5 29H62V49H54.5V29Z" fill="var(--color-brand-dark)" />
          <path d="M54.5 29H62V49H49.5L54.5 41V29Z" fill="var(--color-brand-dark)" />
          <circle cx="58.25" cy="20.5" r="4.75" fill="var(--color-brand)" />
        </svg>
      </span>
      <span
        className="brand-logo-text"
        style={{
          color: "var(--color-ink)",
          fontSize: textSize,
          fontWeight: 700,
          letterSpacing: 0,
          whiteSpace: "nowrap",
        }}
      >
        OpenHomesAI
      </span>
    </span>
  );
}
